import React from "react";
import { SocialIcon } from "react-social-icons";
import WebIcon from "@material-ui/icons/Web";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";

export function WebLink({ text, iconType }) {
  return (
    <ListItem>
      <ListItemIcon>
        {iconType === "website" ? (
          <WebIcon style={{ fontSize: 25 }} />
        ) : (
          <SocialIcon network={iconType} style={{ height: 25, width: 25 }} />
        )}
      </ListItemIcon>
      <ListItemText>{text}</ListItemText>
    </ListItem>
  );
}
